var _defs, _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _path26, _line11, _path27, _line12, _line13, _path28, _polygon, _path29, _path30, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _path31, _path32, _path33, _polyline, _path34, _path35, _path36, _line14, _line15, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 382 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#385f7e;}.cls-2,.cls-4{fill:#e1e6ea;}.cls-14,.cls-2{stroke:#e1e6ea;}.cls-13,.cls-14,.cls-15,.cls-2,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-2{stroke-width:0.5px;}.cls-3{fill:#fff;}.cls-5{fill:#bec4ca;}.cls-13,.cls-14,.cls-6,.cls-7{fill:none;}.cls-6,.cls-7{stroke:#3c4650;}.cls-13,.cls-14,.cls-7{stroke-linecap:round;}.cls-15,.cls-8{fill:#f05f2a;}.cls-9{clip-path:url(#clip-path);}.cls-10{isolation:isolate;}.cls-11{clip-path:url(#clip-path-2);}.cls-12{clip-path:url(#clip-path-3);}.cls-13{stroke:#212c38;}.cls-15{stroke:#fff;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.45,149a.5.5,0,0,0-.49.49.77.77,0,0,0,.36.56.45.45,0,0,0,.13.1l.13.13-.13.16a.94.94,0,0,1-.69.3.92.92,0,0,1-.66-.26l-1.58-1.51a.92.92,0,0,1-.26-.66,1,1,0,0,1,.26-.66l1.08-1.08a1,1,0,0,1,1.31,0l1.54,1.54a.92.92,0,0,1,.26.66.94.94,0,0,1-.3.69l-.16.13-.13-.13a.45.45,0,0,1-.1-.13C159.84,149.12,159.68,149,159.45,149Zm3.84,3.84a.77.77,0,0,0-.36-.56.45.45,0,0,0-.13-.1l-.13-.13.13-.16a.94.94,0,0,1,.69-.3,1,1,0,0,1,.66.26l1.54,1.54a.92.92,0,0,1,.26.66,1,1,0,0,1-.26.66l-1.08,1.05a1,1,0,0,1-1.31,0l-1.51-1.54a.92.92,0,0,1-.26-.66.94.94,0,0,1,.3-.69l.16-.13.13.13a.45.45,0,0,1,.1.13c.2.2.33.36.56.36A.56.56,0,0,0,163.29,152.8Zm3.15-.2-1.54-1.54a1.94,1.94,0,0,0-1.38-.56,2,2,0,0,0-1.41.59l-.16.16-1-1,.16-.16a1.91,1.91,0,0,0,.59-1.41,1.94,1.94,0,0,0-.56-1.38l-1.54-1.54a2,2,0,0,0-2.76,0l-1.08,1.08a2,2,0,0,0,0,2.76l1.54,1.54a1.94,1.94,0,0,0,1.38.56,2,2,0,0,0,1.41-.59l.16-.16,1,1-.16.16a1.91,1.91,0,0,0-.59,1.41,1.94,1.94,0,0,0,.56,1.38l1.54,1.54a2,2,0,0,0,2.76,0l1.08-1.08A1.92,1.92,0,0,0,167,154,2,2,0,0,0,166.44,152.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.98,
    y: 141.98,
    width: 18.28,
    height: 18.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.25,
    y: 145.25,
    width: 11.75,
    height: 11.75
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "external-link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.74,102.82,293,96.08a24.38,24.38,0,0,0-34.46-34.46l-6.74-6.74a.87.87,0,1,0-1.23,1.23l1.7,1.7a31.55,31.55,0,0,0,19.54,53v6.74h-7.08a.89.89,0,0,0,0,1.77h15.94a.89.89,0,0,0,0-1.77h-7.08V111c.54,0,1.09.07,1.63.07a31.24,31.24,0,0,0,21.66-8.65l1.7,1.7a1,1,0,0,0,.61.27.74.74,0,0,0,.61-.27A1,1,0,0,0,299.74,102.82ZM255.68,67.89c-.14,3,.89,6.61,2.86,10.35l-5.65,5.65A23.12,23.12,0,0,1,255.68,67.89Zm11.17,4.49,7.08,7.08-7.08,7.08a41,41,0,0,1-6.13-8.1Zm-6.95,4.49c-2.59-5.18-3.27-10-1.29-12.8l7,7Zm15.25,3.81,7.08,7.08-6.13,6.13a43,43,0,0,1-8.1-6.13ZM283.46,89l7,7c-2.79,2-7.56,1.29-12.8-1.29Zm8.31,5.79-7-7,5.72-5.72C293.06,87.23,293.67,92.07,291.77,94.79Zm-8.31-8.24-7.08-7.08,7.08-7.08a41,41,0,0,1,6.13,8.1Zm0-16.62a45.93,45.93,0,0,0-8-6.2l6.06-6.06a22.74,22.74,0,0,1,9.06,5.11Zm-1.23,1.23-7.08,7.08-7.08-7.08L274.2,65A42.67,42.67,0,0,1,282.23,71.16Zm-15.39-1.23-7-7A7.28,7.28,0,0,1,264,61.76a20.22,20.22,0,0,1,8.65,2.45Zm-7.42,9.81a42.84,42.84,0,0,0,6.2,8l-7.08,7.08a22.74,22.74,0,0,1-5.11-9.06ZM266.84,89a45.93,45.93,0,0,0,8,6.2l-6,6a22.74,22.74,0,0,1-9.06-5.11Zm9.6,7.08a21.38,21.38,0,0,0,9.87,2.86h.48a23.12,23.12,0,0,1-16,2.79Zm18.18-5c.14-3-.89-6.61-2.86-10.35L297.42,75A22.76,22.76,0,0,1,294.63,91Zm2.32-17.91-6.06,6.06a42.84,42.84,0,0,0-6.2-8l7.08-7.08A21.45,21.45,0,0,1,296.94,73.13ZM275.15,56.79a23.6,23.6,0,0,1,4.36.41l-5.65,5.65c-3.75-2-7.35-3-10.35-2.86A23.08,23.08,0,0,1,275.15,56.79Zm0,52.5a29.76,29.76,0,0,1-29.83-29.83A29.42,29.42,0,0,1,253.43,59l3.81,3.81A24.38,24.38,0,0,0,291.7,97.31l3.81,3.81A29.2,29.2,0,0,1,275.15,109.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 170,
    y: 57,
    width: 61,
    height: 105,
    rx: 11,
    ry: 11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.79,113.12V96.8a3,3,0,0,0-3-3H152.42a3,3,0,0,0-3,3v16.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.32,96.68a3.14,3.14,0,0,1,3.14-3.14H224.92V67.74a3.14,3.14,0,0,0-3.14-3.14h-192a3.14,3.14,0,0,0-3.14,3.14V194.33a3.14,3.14,0,0,0,3.14,3.14H67.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71,70.43h81.74A1.58,1.58,0,0,1,154.35,72v3a1.58,1.58,0,0,1-1.58,1.58H71A1.57,1.57,0,0,1,69.46,75V72A1.58,1.58,0,0,1,71,70.43Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30.37,
    y: 92.46,
    width: 32.22,
    height: 6.36,
    rx: 1.39,
    ry: 1.39
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.56,99.64v-3.3A2.45,2.45,0,0,1,152,93.9h71.06a2.44,2.44,0,0,1,2.44,2.44v3.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.75,107.51c-.46,0-.83-.62-.83-1.39v-2c0-.77.37-1.39.83-1.39h39.77c.46,0,.83.62.83,1.39v2c0,.77-.37,1.39-.83,1.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.78,70.43H140.53v6.11h12.24A1.58,1.58,0,0,0,154.35,75V72A1.58,1.58,0,0,0,152.78,70.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,121.8a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.34,121.91V127h1.36a1.3,1.3,0,0,0,1.3-1.3v-2.62a1.3,1.3,0,0,0-1.3-1.3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,132.74a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,138a1.3,1.3,0,0,0,1.3-1.3V134a1.3,1.3,0,0,0-1.3-1.3h-1.36V138Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,148.9a1.3,1.3,0,0,0,1.3-1.3V145a1.3,1.3,0,0,0-1.3-1.3h-1.36v5.22Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,143.68a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,154.63a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,159.85a1.3,1.3,0,0,0,1.3-1.3v-2.62a1.3,1.3,0,0,0-1.3-1.3h-1.36v5.22Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,170.79a1.3,1.3,0,0,0,1.3-1.3v-2.62a1.3,1.3,0,0,0-1.3-1.3h-1.36v5.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,165.57a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,181.73a1.3,1.3,0,0,0,1.3-1.3v-2.62a1.3,1.3,0,0,0-1.3-1.3h-1.36v5.22Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,176.52a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,187.46a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.7,192.68a1.3,1.3,0,0,0,1.3-1.3v-2.62a1.3,1.3,0,0,0-1.3-1.3h-1.36v5.22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,100.23a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.94,111.17a1.3,1.3,0,0,0-1.3,1.3v2.62a1.3,1.3,0,0,0,1.3,1.3H148.5v-5.22Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.61,92.48h-5a1.24,1.24,0,0,0-1.24,1.24v3.87a1.24,1.24,0,0,0,1.24,1.24H61.27a1.27,1.27,0,0,0,1.33-1.16V93.15a1.25,1.25,0,0,1,1.11-1.21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.92,81.59H71a1.24,1.24,0,0,0-1.24,1.24v2.81A1.24,1.24,0,0,0,71,86.87H92.59a1.27,1.27,0,0,0,1.33-1.16V82.26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.61,81.59H123a1.24,1.24,0,0,1,1.24,1.24v2.81A1.24,1.24,0,0,1,123,86.87H101.36A1.27,1.27,0,0,1,100,85.71"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.8,81.59h7.53a1.24,1.24,0,0,1,1.24,1.24v2.81a1.24,1.24,0,0,1-1.24,1.24H130.71a1.27,1.27,0,0,1-1.33-1.16"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 31.56,
    cy: 69.21,
    r: 1.88
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 103.18,
    x2: 49.06,
    y2: 103.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 107.59,
    x2: 46.41,
    y2: 107.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 112,
    x2: 49.06,
    y2: 112
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 150.82,
    x2: 49.06,
    y2: 150.82
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 155.22,
    x2: 46.41,
    y2: 155.22
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 159.63,
    x2: 49.06,
    y2: 159.63
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 116.4,
    x2: 44.28,
    y2: 116.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 120.81,
    x2: 49.06,
    y2: 120.81
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 125.21,
    x2: 46.41,
    y2: 125.21
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 129.62,
    x2: 49.06,
    y2: 129.62
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.45,
    y1: 134.03,
    x2: 41.63,
    y2: 134.03
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 31.56,
    y1: 143.54,
    x2: 63.7,
    y2: 143.54
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M226.86,116.5v76.11a3.26,3.26,0,0,1-3.26,3.26H28.81a3.26,3.26,0,0,1-3.26-3.26V66.27A3.26,3.26,0,0,1,28.81,63H223.08a3.26,3.26,0,0,1,3.26,3.27"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 68.85,
    y1: 91.91,
    x2: 216.5,
    y2: 91.91
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.76,195.87a3.26,3.26,0,0,1-3.26-3.26V95.47a3.26,3.26,0,0,1,3.26-3.26"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 148.5,
    y1: 111.52,
    x2: 183.5,
    y2: 111.52
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 147.84,
    y1: 186.51,
    x2: 198.86,
    y2: 186.51
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33.56,85.23h.5c.69,0,.69-.42.69-.87V83.15H32.87v1.21C32.87,84.83,32.87,85.23,33.56,85.23Zm0-1.44h.59v.81h-.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "41.89 85.61 43.17 85.61 43.17 84.93 42.57 84.93 42.57 83.83 44 83.83 44 83.15 41.89 83.15 41.89 85.61"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.8,82.07v2.3c0,1.31.56,1.94,1.7,1.94h.63c1.12,0,1.69-.67,1.69-2v-.48h5v1.09h-.65v.68h1.33V83.15H35.14v1.16c0,1.09-.41,1.32-1,1.32H33.5c-.65,0-1-.21-1-1.26V82.75H44v-.68Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.45,149a.5.5,0,0,0-.49.49.77.77,0,0,0,.36.56.45.45,0,0,0,.13.1l.13.13-.13.16a.94.94,0,0,1-.69.3.92.92,0,0,1-.66-.26l-1.58-1.51a.92.92,0,0,1-.26-.66,1,1,0,0,1,.26-.66l1.08-1.08a1,1,0,0,1,1.31,0l1.54,1.54a.92.92,0,0,1,.26.66.94.94,0,0,1-.3.69l-.16.13-.13-.13a.45.45,0,0,1-.1-.13C159.84,149.12,159.68,149,159.45,149Zm3.84,3.84a.77.77,0,0,0-.36-.56.45.45,0,0,0-.13-.1l-.13-.13.13-.16a.94.94,0,0,1,.69-.3,1,1,0,0,1,.66.26l1.54,1.54a.92.92,0,0,1,.26.66,1,1,0,0,1-.26.66l-1.08,1.05a1,1,0,0,1-1.31,0l-1.51-1.54a.92.92,0,0,1-.26-.66.94.94,0,0,1,.3-.69l.16-.13.13.13a.45.45,0,0,1,.1.13c.2.2.33.36.56.36A.56.56,0,0,0,163.29,152.8Zm3.15-.2-1.54-1.54a1.94,1.94,0,0,0-1.38-.56,2,2,0,0,0-1.41.59l-.16.16-1-1,.16-.16a1.91,1.91,0,0,0,.59-1.41,1.94,1.94,0,0,0-.56-1.38l-1.54-1.54a2,2,0,0,0-2.76,0l-1.08,1.08a2,2,0,0,0,0,2.76l1.54,1.54a1.94,1.94,0,0,0,1.38.56,2,2,0,0,0,1.41-.59l.16-.16,1,1-.16.16a1.91,1.91,0,0,0-.59,1.41,1.94,1.94,0,0,0,.56,1.38l1.54,1.54a2,2,0,0,0,2.76,0l1.08-1.08A1.92,1.92,0,0,0,167,154,2,2,0,0,0,166.44,152.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.98,
    y: 141.98,
    width: 18.28,
    height: 18.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.25,
    y: 145.25,
    width: 11.75,
    height: 11.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.98,
    y: 141.98,
    width: 18.28,
    height: 18.28
  })))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154,
    y: 120.75,
    width: 63.96,
    height: 1.5,
    rx: 0.75,
    ry: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154,
    y: 125.75,
    width: 67,
    height: 1.5,
    rx: 0.75,
    ry: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154,
    y: 131.75,
    width: 61.35,
    height: 1.5,
    rx: 0.75,
    ry: 0.75
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154,
    y: 137.75,
    width: 52.22,
    height: 1.5,
    rx: 0.75,
    ry: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171,
    y: 150,
    width: 41.49,
    height: 1,
    rx: 0.25,
    ry: 0.25
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M331,138.68h16.62a5.92,5.92,0,0,0,5.87-6V30.44a5.92,5.92,0,0,0-5.87-6H184.35a5.92,5.92,0,0,0-5.87,6V52.32"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M207.25,179.08v1c0,.09,0,.7-.61.7H206c-.53,0-.55-.53-.55-.7v-1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M222.11,176.62H203.37v3.85c0,.65.1,2.62,2.06,2.62h1.37c2.28,0,2.29-2.3,2.29-2.62v-1.39h7.55v2.8H214.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "222.11 179.08 219.12 179.08 219.12 181.88 221.06 181.88"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M193.38,142.65a2.49,2.49,0,0,0,2.26.14l.49-.23a2.17,2.17,0,0,0,.56-2.65l-.84-1.8c-2.46-4.43-7.38-13.69-3.13-21.25,4-7.24,17.4-13.09,21.9-15l4,8.67a2,2,0,0,0,2,1.27,2.27,2.27,0,0,0,2-1.32L234.81,81.1a1.76,1.76,0,0,0,0-1.78,2,2,0,0,0-1.34-1.17L203.31,69.1a2.16,2.16,0,0,0-2.59,3l3.66,7.85c-6.05,2.82-26.2,13-29.85,25.27C170.45,118.68,177,131.54,193.38,142.65Zm16.17-62.72L207,74.53,230,81.37l-9.33,22.28-2.75-5.89a2.31,2.31,0,0,0-2.72-1.12,44.67,44.67,0,0,0-6.86,2.8c-6.87,3.2-16,8.45-19.55,14.89-2.89,5.33-3.06,11.39-.27,18.65-9.06-8.32-12.45-17.3-9.61-26.59,3.19-10.25,22.86-20.62,29.55-23.34.57-.07.91-.62,1.24-1.18A3.21,3.21,0,0,0,209.56,79.93Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.95,29h154.4a5,5,0,0,1,5,5V44.48a0,0,0,0,1,0,0H183.95a0,0,0,0,1,0,0V34A5,5,0,0,1,188.95,29Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256,33.43h81.74A1.58,1.58,0,0,1,339.35,35v3a1.58,1.58,0,0,1-1.58,1.58H256A1.57,1.57,0,0,1,254.46,38V35A1.58,1.58,0,0,1,256,33.43Z"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 302.84,
    y1: 121.51,
    x2: 353.86,
    y2: 121.51
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 177.84,
    y1: 44.51,
    x2: 271,
    y2: 44.51
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.56,79.93,207,74.53,230,81.37l-9.33,22.28-2.75-5.89a2.31,2.31,0,0,0-2.72-1.12,44.67,44.67,0,0,0-6.86,2.8c-6.87,3.2-16,8.45-19.55,14.89-2.89,5.33-3.06,11.39-.27,18.65-9.06-8.32-12.45-17.3-9.61-26.59,3.19-10.25,22.86-20.62,29.55-23.34.57-.07.91-.62,1.24-1.18A3.21,3.21,0,0,0,209.56,79.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.86dcb6f50cc0ef9ae7f08f998f960826.svg";
export { ForwardRef as ReactComponent };